import Flickity from 'flickity'
import on from 'dom-event'
import debounce from 'lodash/debounce'

export default el => {
  const selectors = {
    slider: '.js-blog-slider',
    slide: '.js-blog-slide'
  }

  const slides = [...el.querySelectorAll(selectors.slide)]

  const blogSlider = () => {
    return new Flickity(selectors.slider, {
      prevNextButtons: true,
      pageDots: true,
      cellAlign: 'left',
      freeScroll: false,
      wrapAround: true,
      contain: true
    })
  }

  if (slides.length > 1) {
    blogSlider()
  }
}
